export default __webpack_public_path__ + "static/media/Thankyou_Heading.ca0497f7.svg";